import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BLACK_700, BLACK_900, Button, Callout, Checkbox, Divider, DynamicSvg, GridCol, GridContainer, GridRow, LILAC_500, StateConfigContext, Typography, WHITE, getTestId, isValidObject, useBreakpoint } from '@airtel/air-design-system';
import { useContext, useEffect, useState } from 'react';
import { Image, View } from 'react-native';
import { ButtonWidget } from '../button-widget';
import { getAnchoredActionWidgetStyles } from './AnchoredActionWidgetStyles';
import PriceDiscount from './components/price-discount';
export var AnchoredActionWidgetComponent = props => {
  var _a, _b, _c, _d, _e;
  var _useContext = useContext(StateConfigContext),
    theme = _useContext.theme;
  var _props$type = props.type,
    type = _props$type === void 0 ? 'buttons' : _props$type,
    gratificationText = props.gratificationText,
    gratificationIconName = props.gratificationIconName,
    _props$setCheckedBoxS = props.setCheckedBoxState,
    setCheckedBoxState = _props$setCheckedBoxS === void 0 ? false : _props$setCheckedBoxS,
    _props$checkboxData = props.checkboxData,
    checkboxData = _props$checkboxData === void 0 ? {} : _props$checkboxData,
    onCheckboxSelection = props.onCheckboxSelection,
    onCheckboxSelectionMetaData = props.onCheckboxSelectionMetaData,
    buttonData = props.buttonData,
    _props$isValid = props.isValid,
    isValid = _props$isValid === void 0 ? true : _props$isValid,
    _props$subText = props.subText,
    subText = _props$subText === void 0 ? [] : _props$subText,
    tertiaryButton = props.tertiaryButton,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'checkbox' : _props$variant,
    _props$textOnlyData = props.textOnlyData,
    textOnlyData = _props$textOnlyData === void 0 ? {} : _props$textOnlyData,
    _props$withTopDivider = props.withTopDivider,
    withTopDivider = _props$withTopDivider === void 0 ? false : _props$withTopDivider,
    _props$description = props.description,
    description = _props$description === void 0 ? [] : _props$description,
    onTertiaryButtonPressMetaData = props.onTertiaryButtonPressMetaData,
    onActionCtaPressMetaData = props.onActionCtaPressMetaData,
    logoUrl = props.logoUrl,
    logoUrlSize = props.logoUrlSize,
    gridColumnStyle = props.gridColumnStyle,
    isInsideGridColumn = props.isInsideGridColumn,
    logoImgStyleProps = props.logoImgStyleProps,
    testID = props.testID,
    style = props.style,
    id = props.id,
    _onUserAction = props.onUserAction,
    priceDiscount = props.priceDiscount,
    priceDiscountStyle = props.priceDiscountStyle,
    contentAlignmentDirection = props.contentAlignmentDirection,
    calloutProps = props.calloutProps,
    imageAccessibilityProps = props.imageAccessibilityProps;
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isSmallScreen = _useBreakpoint.isSmallScreen;
  var anchoredActionWidgetStyles = getAnchoredActionWidgetStyles(props, isSmallScreen, theme);
  var _checked = checkboxData.checked;
  var _useState = useState(setCheckedBoxState ? true : _checked !== null && _checked !== void 0 ? _checked : false),
    checked = _useState[0],
    setChecked = _useState[1];
  var _useState2 = useState(!checked),
    buttonDisabled = _useState2[0],
    setButtonDisabled = _useState2[1];
  var hasButtons = !!((_a = buttonData === null || buttonData === void 0 ? void 0 : buttonData.leftCta) === null || _a === void 0 ? void 0 : _a.title) || !!((_b = buttonData === null || buttonData === void 0 ? void 0 : buttonData.rightCta) === null || _b === void 0 ? void 0 : _b.title);
  var hasGratification = gratificationText || gratificationIconName;
  useEffect(() => {
    setButtonDisabled(!isValid || !checked);
  }, [isValid, checked]);
  useEffect(() => {
    setChecked(setCheckedBoxState ? true : _checked);
  }, [_checked, setCheckedBoxState]);
  var onCheckboxPress = data => {
    setChecked(prevState => {
      onCheckboxSelection === null || onCheckboxSelection === void 0 ? void 0 : onCheckboxSelection(Object.assign(Object.assign({}, data), {
        checked: !prevState
      }));
      onCheckboxSelectionMetaData && (_onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(Object.assign({
        id
      }, onCheckboxSelectionMetaData), Object.assign(Object.assign(Object.assign({}, data), {
        checked: !prevState
      }), props)));
      return !prevState;
    });
  };
  return _jsxs(View, Object.assign({
    style: style
  }, getTestId(testID), {
    children: [hasGratification && _jsxs(View, Object.assign({
      style: anchoredActionWidgetStyles.gratification
    }, getTestId(testID, 'gratification_container'), {
      children: [!!gratificationIconName && _jsx(DynamicSvg, Object.assign({
        iconName: gratificationIconName,
        fontSize: 24,
        color: WHITE,
        style: anchoredActionWidgetStyles.gratificationIcon
      }, getTestId(testID, 'gratificationIcon'))), _jsx(Typography, Object.assign({
        color: WHITE,
        text: gratificationText,
        type: isSmallScreen ? 'body-para-xs' : 'body-para-sm'
      }, getTestId(testID, 'gratificationText')))]
    })), withTopDivider && _jsx(Divider, Object.assign({
      height: 1,
      color: LILAC_500
    }, getTestId(testID, 'divider'))), _jsxs(GridContainer, Object.assign({
      style: [anchoredActionWidgetStyles.content]
    }, isInsideGridColumn && {
      noMargin: true,
      fullWidth: true
    }, {
      children: [isValidObject(calloutProps) && _jsx(Callout, Object.assign({}, calloutProps)), _jsxs(GridRow, Object.assign({
        noMargin: true
      }, {
        children: [_jsxs(GridCol, Object.assign({
          breakpoints: {
            lg: isInsideGridColumn ? 6 : 8
          },
          noGutter: true,
          style: [anchoredActionWidgetStyles.gridColumnStyle, gridColumnStyle]
        }, {
          children: [variant === 'checkbox' && isValidObject(checkboxData) && _jsx(Checkbox, Object.assign({}, Object.assign(Object.assign({}, checkboxData), {
            multiTextLabel: isValidObject(checkboxData === null || checkboxData === void 0 ? void 0 : checkboxData.multiTextLabel) && ((_c = checkboxData === null || checkboxData === void 0 ? void 0 : checkboxData.multiTextLabel) === null || _c === void 0 ? void 0 : _c.map(singleText => Object.assign(Object.assign({}, singleText), {
              onPress: () => {
                (singleText === null || singleText === void 0 ? void 0 : singleText.hyperLinkPressMetaData) && (_onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(Object.assign({
                  id
                }, singleText === null || singleText === void 0 ? void 0 : singleText.hyperLinkPressMetaData), singleText));
              }
            })))
          }), {
            checked: checked,
            size: isSmallScreen ? 'sm' : 'md',
            onPress: data => onCheckboxPress(data),
            onActionCtaPress: () => {
              onActionCtaPressMetaData && _onUserAction(Object.assign({
                id
              }, onActionCtaPressMetaData), checkboxData);
            },
            style: anchoredActionWidgetStyles.checkbox
          }, getTestId(testID, 'checkbox'))), _jsx(GridCol, Object.assign({
            breakpoints: {
              lg: isInsideGridColumn ? 8 : 6
            },
            noGutter: true,
            style: anchoredActionWidgetStyles.gridStyle
          }, {
            children: priceDiscount && (priceDiscount === null || priceDiscount === void 0 ? void 0 : priceDiscount.length) > 0 && _jsx(PriceDiscount, {
              priceDiscount: priceDiscount,
              style: [priceDiscountStyle, anchoredActionWidgetStyles.priceDiscount],
              rowAlignmentDirection: contentAlignmentDirection
            })
          })), !isSmallScreen && _jsx(GridCol, Object.assign({
            breakpoints: {
              lg: isInsideGridColumn ? 6 : 4
            },
            noGutter: true,
            style: anchoredActionWidgetStyles.gridStyle
          }, {
            children: (subText === null || subText === void 0 ? void 0 : subText.length) > 0 && _jsx(View, {
              children: _jsx(Typography, Object.assign({
                type: "body-para-" + (isSmallScreen ? 'xs' : 'sm'),
                color: BLACK_700,
                multiText: subText,
                textAlignment: "center"
              }, getTestId(testID, 'subText')))
            })
          })), variant === 'textOnly' && isValidObject(textOnlyData) && _jsxs(View, Object.assign({
            style: anchoredActionWidgetStyles.checkbox
          }, {
            children: [(textOnlyData === null || textOnlyData === void 0 ? void 0 : textOnlyData.label) && _jsx(Typography, Object.assign({
              text: textOnlyData === null || textOnlyData === void 0 ? void 0 : textOnlyData.label,
              type: "body-para-sm",
              color: BLACK_900
            }, getTestId(testID, 'text_only_data'))), (textOnlyData === null || textOnlyData === void 0 ? void 0 : textOnlyData.actionCtaText) && _jsx(Button, Object.assign({
              size: "sm",
              title: textOnlyData === null || textOnlyData === void 0 ? void 0 : textOnlyData.actionCtaText,
              buttonType: "tertiary",
              style: anchoredActionWidgetStyles.actionCta,
              onPress: () => {
                (textOnlyData === null || textOnlyData === void 0 ? void 0 : textOnlyData.actionCtaPressMetaData) && (_onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(Object.assign({
                  id
                }, textOnlyData === null || textOnlyData === void 0 ? void 0 : textOnlyData.actionCtaPressMetaData)));
              }
            }, getTestId(testID, 'text_only_action_cta')))]
          }))]
        })), _jsx(GridCol, Object.assign({
          breakpoints: {
            lg: isInsideGridColumn ? 6 : 4
          },
          noGutter: true,
          style: anchoredActionWidgetStyles.gridStyleButton
        }, {
          children: type == 'buttons' && hasButtons && _jsx(ButtonWidget, Object.assign({
            id: id
          }, getTestId(testID, 'buttons'), buttonData, {
            leftCta: Object.assign(Object.assign(Object.assign(Object.assign({}, getTestId(testID, 'leftCta')), {
              size: 'md',
              disabled: buttonDisabled
            }), buttonData === null || buttonData === void 0 ? void 0 : buttonData.leftCta), (buttonDisabled || ((_d = buttonData === null || buttonData === void 0 ? void 0 : buttonData.leftCta) === null || _d === void 0 ? void 0 : _d.disabled)) && {
              style: {}
            })
          }, isValidObject(buttonData === null || buttonData === void 0 ? void 0 : buttonData.rightCta) && {
            rightCta: Object.assign(Object.assign(Object.assign(Object.assign({}, getTestId(testID, 'rightCta')), {
              size: 'md',
              disabled: buttonDisabled
            }), buttonData === null || buttonData === void 0 ? void 0 : buttonData.rightCta), (buttonDisabled || ((_e = buttonData === null || buttonData === void 0 ? void 0 : buttonData.rightCta) === null || _e === void 0 ? void 0 : _e.disabled)) && {
              style: {}
            })
          }, {
            onUserAction: (data, extraData) => {
              _onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(data, Object.assign({
                actionData: extraData
              }, props));
            }
          }))
        }))]
      })), isSmallScreen && (subText === null || subText === void 0 ? void 0 : subText.length) > 0 && _jsx(View, Object.assign({
        style: anchoredActionWidgetStyles.metaSpacer
      }, {
        children: _jsx(Typography, Object.assign({
          type: "body-para-" + (isSmallScreen ? 'xs' : 'sm'),
          color: BLACK_700,
          multiText: subText,
          textAlignment: "center"
        }, getTestId(testID, 'subText')))
      })), (description === null || description === void 0 ? void 0 : description.length) > 0 && _jsx(View, Object.assign({
        style: anchoredActionWidgetStyles.metaSpacer
      }, {
        children: _jsx(Typography, Object.assign({
          type: "body-para-" + (isSmallScreen ? 'xs' : 'sm'),
          color: BLACK_700,
          multiText: description,
          textAlignment: "center"
        }, getTestId(testID, 'description')))
      })), !!tertiaryButton && _jsx(Button, Object.assign({
        size: isSmallScreen ? 'md' : 'lg',
        buttonType: "tertiary",
        title: tertiaryButton,
        onPress: () => {
          onTertiaryButtonPressMetaData && (_onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(Object.assign({
            id
          }, onTertiaryButtonPressMetaData), props));
        },
        style: anchoredActionWidgetStyles.metaSpacer
      }, getTestId(testID, 'tertiaryButton'))), !!logoUrl && _jsx(Image, Object.assign({
        resizeMode: "contain",
        style: [anchoredActionWidgetStyles.metaSpacer, logoImgStyleProps],
        source: {
          uri: logoUrl,
          width: (logoUrlSize === null || logoUrlSize === void 0 ? void 0 : logoUrlSize.width) || 52,
          height: (logoUrlSize === null || logoUrlSize === void 0 ? void 0 : logoUrlSize.height) || 28
        }
      }, getTestId(testID, 'logoUrl'), imageAccessibilityProps))]
    }))]
  }));
};
AnchoredActionWidgetComponent.genericRendererKey = 'AirAnchoredActionWidget';